import React from "react";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  const styles = {
    container: {
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f8fafc"
    },
    card: {
      textAlign: "center",
      backgroundColor: "#ffffff",
      padding: "48px 56px",
      borderRadius: "12px",
      boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
    },
    code: {
      fontSize: "64px",
      fontWeight: 600,
      color: "#1f2937"
    },
    title: {
      marginTop: "8px",
      fontSize: "20px",
      fontWeight: 500,
      color: "#111827"
    },
    text: {
      marginTop: "12px",
      fontSize: "14px",
      color: "#6b7280"
    },
    button: {
      marginTop: "28px",
      padding: "10px 24px",
      backgroundColor: "#db2777",
      color: "#ffffff",
      border: "none",
      borderRadius: "6px",
      fontSize: "14px",
      cursor: "pointer"
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.code}>403</div>
        <div style={styles.title}>Access Denied</div>
        <div style={styles.text}>
          You don’t have permission to view this page.
        </div>

        <button
          style={styles.button}
          onClick={() => navigate("/")}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
